import React from 'react';
import { Notification } from 'ui-toolkit';
import { validateItem, validateItemAll } from './validateItem';
import { IValidationProps } from './Validation';

export const ItemValidationContainer: React.FC<IValidationProps> = ({
  currentLineItem,
  sections,
  sectionDefinitions,
  tags = [],
  className,
}) => {
  const warnings = [];

  if (currentLineItem) {
    warnings.push(
      ...validateItem(
        currentLineItem.statementFees,
        sectionDefinitions.flatMap((t) => t.statementSettlementAndFeeCategoryDefinitions) ?? []
      )
    );
  } else {
    warnings.push(
      ...validateItemAll({
        sections: sections,
        sectionDefinitions: sectionDefinitions,
        tags: tags,
      })
    );
  }

  return (
    <>
      {!!warnings.length && !!className && (
        <div className={className} data-test-id={'item-validation-warning-wrapper'}>
          {warnings.map((t) => (
            <Notification key={t} message={t} type={'warning'} data-test-id="item-validation-warning" />
          ))}
        </div>
      )}
      {!!warnings.length &&
        !className &&
        warnings.map((t) => (
          <Notification key={t} message={t} type={'warning'} data-test-id="item-validation-warning" />
        ))}
    </>
  );
};
